// DS: i7.26
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorFontFamily = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10 5H3.5a1 1 0 00-1 1v1a1 1 0 002 0h2v11a1 1 0 102 0V7H10V5zM11.5 7h4v11a1 1 0 102 0V7h2a1 1 0 102 0V6a1 1 0 00-1-1h-9v2z"
    })));
};
EditorFontFamily.displayName = 'EditorFontFamily';
export default EditorFontFamily;

//# sourceMappingURL=EditorFontFamily.js.map